import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { TDR, toLuxon } from 'tdr-common';
import { getCdnImageUri } from '../../helpers/getCDNURI';
import Pencil from '../../icons/Edit.svg';
import { ImageCard, ImageCardAsset, ImageCardHeader, ImageCardHeaderPrimary, ImageCardHeaderTitle } from '../image-card/ImageCard';
import styles from './BookingDetails.module.scss';
import { BookingDetailsSummary } from '../booking-details-summary/BookingDetailsSummary';

type BookingDetailsProps = {
	table: TDR.Table;
	restaurant: TDR.Restaurant;
	reservation: TDR.Reservation;
	checkCutoffs: (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
};

export const BookingDetails = ({
	table,
	restaurant,
	reservation,
	checkCutoffs
}: BookingDetailsProps) => {
	const { t } = useTranslation();
	const imageSrc = getCdnImageUri(table.carouselImagePath, {
		width: 359,
		fit: 'crop',
		dpr: 2
	});

	const searchFilterDate = toLuxon(reservation.time.seconds, restaurant.timezone).toFormat('yyyy-MM-dd');
	const searchFilterTime = toLuxon(reservation.time.seconds, restaurant.timezone).toFormat('HH:mm');
	const searchFilters = { groupSize: reservation.guests, date: searchFilterDate, time: searchFilterTime };

	return (
		<div>
			{table && (
				<div className={styles.Card}>
					<ImageCard height={240} brightness={restaurant.brightness ?? 1} contrast={restaurant.contrast ?? 1}>
						<ImageCardAsset src={imageSrc} alt={table.name} />
						<ImageCardHeader>
							<ImageCardHeaderPrimary>
								<ImageCardHeaderTitle>
									<span>{table.name}</span>
								</ImageCardHeaderTitle>
							</ImageCardHeaderPrimary>
						</ImageCardHeader>
					</ImageCard>

					<BookingDetailsSummary searchFilters={searchFilters} />

					<div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
						<Link to='modify' aria-label={t('aria.modify_booking')} className="bg-tablz-med-gray-2 rounded-2xl border border-tablz-med-gray-4 flex gap-2 justify-center items-center py-6" onClick={checkCutoffs}>
							<img src={Pencil} alt={t('aria.modify_booking')} />
							<span>{t('actions.modify_booking_details')}</span>
						</Link>

						<Link
							to='modify/seating-options'
							aria-label={t('aria.edit_seating_option')}
							className="bg-tablz-med-gray-2 rounded-2xl border border-tablz-med-gray-4 flex gap-2 justify-center items-center py-6"
							onClick={checkCutoffs}
						>
							<img src={Pencil} alt={t('aria.change_seat_selection')} />
							<span>{t('actions.change_seat_selection')}</span>
						</Link>
					</div>
				</div>
			)}
		</div>
	);
};

